import dataGridTheme from './DataGrid';

export default dataGridTheme;
